module.exports = __webpack_public_path__ + "media/images/star_off-aaeed409f24e13e9e5eeb34294549f68.svg";